import React, { useState, useCallback, useEffect } from 'react';
import { Button } from '@saleshandy/design-system';
import { ChevronDown, ChevronUp } from '@saleshandy/icons';
import Transfer from '../../../../../../../../../shared/design-system/components/transfer';
import { Placement } from '../../../../../../../../../shared/design-system/components/overlay/enums';
import { ActivityBy } from '../../../../../../../enums/prospect';

type ActivityTypeFiltersProps = {
  selectedActivityTypes?: string[];
  onApply?: (selectedActivityTypes: string[]) => void;
};

const ActivityTypeFilters: React.FC<ActivityTypeFiltersProps> = ({
  selectedActivityTypes,
  onApply,
}) => {
  const options = [
    { key: ActivityBy.Prospect, label: 'By Prospect' },
    { key: ActivityBy.User, label: 'By Users' },
    { key: ActivityBy.System, label: 'By System' },
  ];

  const [selectedOptions, setSelectedOptions] = useState<string[]>(
    selectedActivityTypes || options.map((option) => option.key),
  );
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (selectedActivityTypes) {
      setSelectedOptions(selectedActivityTypes);
    }
  }, [selectedActivityTypes]);

  const getLabel = (): string => {
    if (selectedOptions.length === options.length) {
      return 'Activities Types (All)';
    }
    if (selectedOptions.length === 1) {
      return `1 Activity type selected`;
    }
    return `${selectedOptions.length} Activity types selected`;
  };

  const handleChange = (key: string, checked: boolean) => {
    if (checked) {
      setSelectedOptions((prev) => [...prev, key]);
    } else if (selectedOptions.length > 1) {
      setSelectedOptions((prev) =>
        prev.filter((optionKey) => optionKey !== key),
      );
    }
  };

  const onToggle = useCallback((value: boolean) => {
    setShow(value);
  }, []);

  return (
    <Transfer
      show={show}
      onToggle={onToggle}
      className="activity-filter-dropdown activity-filter activity-type-filter"
      showSearch={false}
      multiSelect
      options={options}
      selectedOptionKey={selectedOptions}
      optionRenderer={(option) => (
        <span
          className={`sequence-name-item ${
            selectedOptions.length === 1 && selectedOptions.includes(option.key)
              ? 'only-one-selected'
              : ''
          }`}
        >
          {option.label}
        </span>
      )}
      onChange={(selectedActivityOptions) => {
        if (selectedActivityOptions.length > 0) {
          setSelectedOptions(
            selectedActivityOptions.map((option) => option.key),
          );
        }
      }}
      placement={Placement.BottomStart}
      footer={
        <>
          {/* <Checkbox
            checked={selectedOptions.length === options.length}
            intermediate={
              selectedOptions.length > 0 &&
              selectedOptions.length < options.length
            }
            label="Select All"
            onChange={(checked) => {
              if (checked) {
                setSelectedOptions(options.map((option) => option.key));
              } else {
                setSelectedOptions([]);
              }
            }}
          /> */}
          <Button
            onClick={() => {
              setShow(false);
              onApply?.(selectedOptions);
            }}
            disabled={selectedOptions?.length === 0}
          >
            Apply
          </Button>
        </>
      }
    >
      <Button
        className="transfer-select-btn btn-white w-1 activity-type"
        variant="tertiary"
        onClick={() => setShow(!show)}
        style={{ width: '13.5rem' }}
      >
        <div className="transfer-select-btn-content">
          <span>{getLabel()}</span>
        </div>
        <div className="bs-select-box-icon-wrapper">
          {show ? <ChevronUp /> : <ChevronDown />}
        </div>
      </Button>
    </Transfer>
  );
};

export default ActivityTypeFilters;
